module.exports = __webpack_public_path__ + "img/05.e3fffc6b.jpg";